<div
    [ngClass]="{'container--hasChips': value && value.length > 0}"
>
    <div
        class="container-topRow"
        role="group"
        [attr.aria-labelledby]="id + '_label'"
        [attr.aria-describedby]="id + '_chips'"
    >
        <agpr-dropdown
            [id]="id + '_dropdown'"
            name="dropdown"
            class="dropdown"
            [options]="dropdownOptions"
            [(ngModel)]="dropdownValue"
            (ngModelChange)="onDropdownChange($event)"
            [scaleDropdownLabel]="true"
            [ariaLabel]="dropdownAriaLabel"
            [disabled]="disabled"
            [showHiddenOption]="showHiddenOption"
        ></agpr-dropdown>
        <agpr-autocomplete
            [id]="id + '_autocomplete'"
            name="autocomplete"
            class="autocomplete"
            [dropdown]="true"
            [forceSelection]="true"
            [forceClearAfterSelection]="true"
            [placeholder]="selectedField?.placeholder"
            [suggestionsFetcher]="selectedField?.suggestionsFetcher"
            [labelField]="selectedField?.labelLookupValue"
            [(ngModel)]="newChip"
            (ngModelChange)="addChip($event)"
            [ariaLabel]="selectedField?.placeholder"
            [disabled]="disabled"
            [showHiddenOption]="showHiddenOption"
        ></agpr-autocomplete>
    </div>
    <div
        *ngIf="hasChips"
        [id]="id + '_chips'"
        class="chips-bottomRow"
    >
        <ng-container
            *ngFor="let field of value; index as i"
        >
            <label
                *ngIf="field.value.length > 0"
                class="chips-fieldLabel"
                [id]="id + '_chipGroupLabel_' + i"
            >
                <span
                    *ngIf="i !== 0 && value[0].value.length > 0"
                > {{ 'and' | localize | uppercase }} </span>{{ field.headerLabel | localize }}
            </label>
            <ul role="group" [attr.aria-labelledby]="id + '_chipGroupLabel_' + i" class="agpr-chips">
                <li
                    *ngFor="let chip of field.value; index as i"
                    class="agpr-chip"
                    [id]="id + '.chip_' + i"
                    [attr.aria-label]="(field.labelLookupValue ? chip[field.labelLookupValue] : chip) | localize"
                >
                    <span class="agpr-chip-label">
                        {{ (field.labelLookupValue ? chip[field.labelLookupValue] : chip) | localize }}
                    </span>
                    <agpr-button
                        [id]="id + '.chip_' + i + '.delete'"
                        class="agpr-chip-button"
                        [style]="buttonTypes.icon"
                        icon="agpr-i-close"
                        tooltip="Common.forms.chips.delete"
                        tooltipPosition="top"
                        (click)="removeChip(field.type, chip)"
                        [ariaLabel]="((field.labelLookupValue ? chip[field.labelLookupValue] : chip) | localize) + ' ' + ('Common.forms.chips.delete' | localize)"
                    ></agpr-button>
                </li>
            </ul>
        </ng-container>
    </div>
</div>
